<template>
  <div v-loading="loading" class="alarmClass">
    <div>
      <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="105px">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="所属车场" prop="spaceId">
              <el-select
                v-model="form.spaceId"
                disabled
                style="width:100%"
                placeholder="所属车场"
                @change="spaceIdChange"
              >
                <el-option
                  v-for="item in spaceIdList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="优惠规则" prop="discountName">
              <el-input
                clearable
                :disabled="model == 'view'"
                v-model="form.discountName"
                placeholder="请输入优惠规则名称"
                maxlength="30"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="车辆身份" prop="packageType">
              <el-select
                :disabled="model == 'view'"
                @change="packageTypeChange"
                v-model="form.packageType"
                style="width:100%"
                placeholder="请选择车辆身份"
              >
                <el-option
                  v-for="item in packageTypeList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="收费规则" prop="carFeeRuleId">
              <el-select
                :disabled="model == 'view'"
                v-model="form.carFeeRuleId"
                style="width:100%"
                placeholder="请输入收费规则"
              >
                <el-option
                  v-for="item in carRuleList"
                  :key="item.id"
                  :label="item.setmealName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="缴费期数(月)" prop="payPeriods">
              <el-input-number
                :disabled="model == 'view'"
                :controls="false"
                v-model="form.payPeriods"
                :min="1"
                :max="999"
                label="请输入缴费期数(月)"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="减免类型" prop="discountType">
              <el-radio-group
                :disabled="model == 'view'"
                v-model="form.discountType"
                @input="discountTypeChange"
              >
                <el-radio :label="1">减免月份</el-radio>
                <el-radio :label="2">减免固定金额</el-radio>
                <el-radio :label="3">优惠折扣</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="form.discountType == 1">
            <el-form-item label="减免" prop="discountNumber">
              <el-input-number
                :disabled="model == 'view'"
                :controls="false"
                v-model="form.discountNumber"
                :min="1"
                :max="999"
                label="减免"
              ></el-input-number
              ><span>个月</span>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="form.discountType == 2">
            <el-form-item label="减免" prop="discountNumber">
              <money-input
                :disabled="model == 'view'"
                v-model="form.discountNumber"
                placeholder="请输入减免金额"
                template="append"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="form.discountType == 3">
            <el-form-item label="减免" prop="discountNumber">
              <el-input-number
                :disabled="model == 'view'"
                :precision="2"
                :controls="false"
                v-model="form.discountNumber"
                :min="0"
                :max="1"
                label="减免"
              ></el-input-number
              ><span>折扣：原价为1，0.8即为8折优惠/8折</span>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入备注"
                v-model="form.remark"
                :disabled="model == 'view'"
                maxlength="200"
                show-word-limit
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="    text-align: right;" v-if="model != 'view'">
      <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
        {{ model == 'add' ? '提交' : '修改' }}
      </el-button>
      <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small">
        取消
      </el-button>
    </div>
  </div>
</template>
<script>
import { getDictionary } from '@/api/common.js';
import {
  getParkList,
  getCarRuleList,
  carfeerulediscountAdd,
  carfeerulediscountUpdate,
  carfeerulediscountDetail,
} from './index.js';
export default {
  components: {},
  props: {
    row: {
      default: {},
    },
    spaceId: {},
    model: {},
  },
  data() {
    return {
      spaceStatusData: [
        {
          dictKey: '1',
          dictValue: '已出售',
        },
        {
          dictKey: '2',
          dictValue: '空闲',
        },
      ],
      isDoubleData: [
        {
          dictKey: '0',
          dictValue: '否',
        },
        {
          dictKey: '1',
          dictValue: '是',
        },
      ],

      regionList: [],
     

      form: {
        spaceId: '',
        discountName: '',
        packageType: '',
        // carType:'',
        payPeriods: '',
        discountType: '',
        discountNumber: '',
        remark: '',
        carFeeRuleId: '',
      },

      formRules: {
        spaceId: [{ required: true, message: '所属车场不能为空', trigger: 'blur' }],
        packageType: [{ required: true, message: '变量模板不能为空', trigger: 'change' }],
        carFeeRuleId: [{ required: true, message: '收费规则不能为空', trigger: 'change' }],
        discountName: [{ required: true, message: '优惠规则名称不能为空', trigger: 'blur' }],
        payPeriods: [{ required: true, message: '缴费期数不能为空', trigger: 'blur' }],
        discountType: [{ required: true, message: '减免类型不能为空', trigger: 'change' }],
        discountNumber: [{ required: true, message: '减免不能为空', trigger: 'change' }],
      },
      tableHeight: '',
      spaceIdList: [],
      packageTypeList: [],
      carRuleList: [],
    };
  },
  created() {
    this.initData();
  },
  mounted() {},
  watch: {},
  methods: {
    //减免类型改变减免清空
    discountTypeChange() {
      console.log('zcxz');
      this.form.discountNumber = '';
    },
    initData() {
      getParkList().then((res) => {
        this.spaceIdList = res.data;
      });
      getDictionary('package_type').then((res) => {
        this.packageTypeList = res.data;
      });
      if (this.model == 'add') {
        this.form.spaceId = this.spaceId;
      } else {
        carfeerulediscountDetail({ id: this.row.id }).then((res) => {
          this.form = res.data;
          this.form.packageType += '';
          getCarRuleList({ spaceId: this.form.spaceId, packageType: this.form.packageType }).then(
            (res) => {
              this.carRuleList = res.data;
            }
          );
        });
      }
    },
    //车辆身份切换清空收费规则在获取规则
    packageTypeChange() {
      this.form.carFeeRuleId = '';
      this.carRuleList = [];
      getCarRuleList({ spaceId: this.form.spaceId, packageType: this.form.packageType }).then(
        (res) => {
          this.carRuleList = res.data;
        }
      );
    },
    saveRecord() {
      this.$refs['formRef'].validate((valid) => {
        if (valid) {
          if (this.model == 'add') {
            carfeerulediscountAdd(this.form).then((res) => {
              this.$message({
                type: 'success',
                message: '新增成功!',
              });
              this.$emit('success');
            });
          } else {
            carfeerulediscountUpdate(this.form).then((res) => {
              this.$message({
                type: 'success',
                message: '编辑成功!',
              });
              this.$emit('success');
            });
          }
        }
      });
    },
    cancleRecord() {
      this.$emit('cancle');
    },
  },
};
</script>
<style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
</style>
